export enum RecurringInteraction {
  NoRepeat = 1,
  Daily = 2,
  EveryMonday = 3,
  EveryWeekDay = 4,
  Custom = 5,
}
